/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { ConstructionSite } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConstructionSitesService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getConstructionSites(): Observable<ConstructionSite[]> {
    return this.httpClient.get<ConstructionSite[]>(`${environment.backendServer}/api/construction_sites`, {
      headers: this.LD_JSON_HEADERS
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  getConstructionSite(id: string): Observable<ConstructionSite> {
    return this.httpClient.get<ConstructionSite>(`${environment.backendServer}/api/construction_sites/${this.extractId(id)}`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  getActiveConstructionSitesFor(customerId: number, activeOnly = true): Observable<ConstructionSite[]> {
    let url = `${environment.backendServer}/api/construction_sites?customer=${customerId}`;
    if (activeOnly) {
      url += '&active=1';
    }

    return this.httpClient.get<ConstructionSite[]>(url, {
      headers: this.LD_JSON_HEADERS
    }).pipe(
      map(response => response['hydra:member'])
    );
  }
}
